"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalBoatersValidator = void 0;
const base_1 = require("./base");
const validators_1 = require("./validators");
const AdditionalBoatersValidator = (question) => {
    const { listProperties } = question.metadata;
    const internalValidators = listProperties.reduce((map, prop) => {
        const validator = validators_1.ValidatorsFactory.createFromRaw(prop);
        map[prop.property] = validator;
        return map;
    }, {});
    const entryValidator = new base_1.BaseValidator();
    Object.keys(internalValidators).forEach(key => {
        entryValidator.addRule(item => {
            const propValidator = internalValidators[key];
            propValidator.validate(item[key]);
            return propValidator.errors.length ? propValidator.errors[0] : undefined;
        });
    });
    const rule = (list = []) => {
        if (!Array.isArray(list))
            return undefined;
        const errors = [];
        list.forEach((entry, idx) => {
            if (!entryValidator.validate(entry)) {
                const firstError = entryValidator.errors[0];
                if (firstError) {
                    firstError.message = `Boater ${idx + 1}: ${firstError.message}`;
                    firstError.meta = firstError.meta || {};
                    firstError.meta.index = idx;
                }
                errors.push(firstError);
            }
        });
        return errors.length ? errors[0] : undefined;
    };
    return rule;
};
exports.AdditionalBoatersValidator = AdditionalBoatersValidator;
